import { useState } from 'react';
import EditContactModal from '../../../components/EditContactModal';
import { editContact } from '../../../redux/actions';
import { useRedux } from '../../../hooks';

interface BasicDetailsProps {
    chatUserDetails: any;
}
const BasicDetails = ({ chatUserDetails }: BasicDetailsProps) => {
    const { dispatch } = useRedux();
    /* Edit contact modal handeling */
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    /* onInvite handeling */
    const onEditContact = (data: any) => {
        dispatch(editContact(data, chatUserDetails.personId));
        closeModal();
    };

    return (
        <>
            <div className="pb-2 pt-4">
                <h5 className="font-size-11 text-uppercase mb-2">Info :</h5>
                <div>
                    <div className="d-flex align-items-end">
                        <div className="flex-grow-1">
                            <p className="text-muted font-size-14 mb-1">
                                First Name
                            </p>
                        </div>
                        <div className="flex-shrink-0">
                            <button
                                type="button"
                                className="btn btn-sm btn-soft-primary"
                                onClick={openModal}
                            >
                                Edit
                            </button>
                        </div>
                    </div>
                    <h5 className="font-size-14">
                        {chatUserDetails.firstName}
                    </h5>
                </div>

                <div className="mt-4">
                    <p className="text-muted font-size-14 mb-1">Last Name</p>
                    <h5 className="font-size-14">
                        {chatUserDetails.lastName
                            ? chatUserDetails.lastName
                            : '-'}
                    </h5>
                </div>

                <div className="mt-4">
                    <p className="text-muted font-size-14 mb-1">Phone Number</p>
                    <h5 className="font-size-14">
                        {chatUserDetails.phoneNumber}
                    </h5>
                </div>

                <div className="mt-4">
                    <p className="text-muted font-size-14 mb-1">Display Name</p>
                    <h5 className="font-size-14">
                        {chatUserDetails.displayName
                            ? chatUserDetails.displayName
                            : `${chatUserDetails.firstName} ${chatUserDetails.lastName}`}
                    </h5>
                </div>

                {/* <div className="mt-4">
                    <p className="text-muted font-size-14 mb-1">Email</p>
                    <h5 className="font-size-14">
                        {chatUserDetails.email ? chatUserDetails.email : '-'}
                    </h5>
                </div> */}

                {/* <div className="mt-4">
                    <p className="text-muted font-size-14 mb-1">Location</p>
                    <h5 className="font-size-14 mb-0">
                        {chatUserDetails.location
                            ? chatUserDetails.location
                            : '-'}
                    </h5>
                </div> */}
            </div>
            {/* Edit contact modal */}
            {isOpen && (
                <EditContactModal
                    isOpen={isOpen}
                    onClose={closeModal}
                    onEdit={onEditContact}
                    chatUserDetails={chatUserDetails}
                />
            )}
        </>
    );
};

export default BasicDetails;
